/*
 * vega-tooltip appends its element to ``<body>``, outside the chart wrapper, so
 * the font and lining figures set on the wrapper cannot reach it. Set them here,
 * matching ``CHART_FONT`` in vegaTheme.
 */
#vg-tooltip-element,
#vg-tooltip-element.vg-tooltip {
  font-family: 'Raleway', 'Inter', sans-serif;
  font-variant-numeric: lining-nums;
}

/* Above full-screen overlays such as the expanded chat figure (z-index 10000). */
#vg-tooltip-element.vg-tooltip {
  z-index: 10001;
}
